import { render, staticRenderFns } from "./TgsqBrowse.vue?vue&type=template&id=c52c21ec"
import script from "./TgsqBrowse.vue?vue&type=script&lang=js"
export * from "./TgsqBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports